import { reportErrorToConsole } from '@src/shared/services/error-logger'
import { apiClient } from '@src/shared/services/http-common'

export interface JwtToken {
  jwt: string
}

export async function signIn(data: JwtToken): Promise<JwtToken> {
  return await apiClient
    .post('/GenerateJwtToken', data)
    .then((response) => {
      return response.data as JwtToken
    })
    .catch((error) => {
      reportErrorToConsole(error)
      return {} as JwtToken
    })
}
